import React from 'react';
import type { Customer } from '../types';

export const CustomerContext = React.createContext<Customer | null>(null);
